import React from 'react'
import students from '../../../../images/main/students.jpg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import vector_right from "../../../../images/basic/header/vector_right.svg";

const TeachWithGenerium = () => {
  return (
    <div className={styles.wrapper}>
       <div className={styles.wr2}>
        <div className={styles.left}>
          <p className={styles.title}>Возможности для студентов</p>
          <img src={students} alt='students' draggable='false'/>
        </div>
        <div className={styles.right}>
          <div className={styles.desc}>
            <div className={styles.title}>
              Получи образование с Generium
            </div>
            <div class={styles.img_mobile}>
              <img src={students} alt='students' draggable='false'/>
            </div>
            <div className={styles.preview}>
              <p className={styles.text}>
                На образовательной программе ты познакомишься с индустрией биотехнологий, послушаешь курсы от практикующих экспертов и пройдешь практику в Generium.
              </p>
            </div>
            <div className={styles.down}>
              <div className={styles.down_wrapper}>
                <Link to='/students/education' className={styles.button}>
                  Узнать больше о программах <span>&rarr;</span>
                </Link>
                <Link to='/students/education' className={styles.button_mobile}>
                  Узнать больше <span>&rarr;</span>
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.img}>
            <img src={students} alt='students' draggable='false'/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeachWithGenerium
